export default "__VITE_ASSET__D9VMkp6K__";